import { useEffect, useState } from "react";
import { Calculator, MessageCircle } from "lucide-react";
import { useNoIndex } from "../hooks/useNoIndex";
import { api, resolveMediaUrl } from "../lib/api";
import { Navbar } from "../components/layout/Navbar";
import { Footer } from "../components/layout/Footer";
import { PageHero } from "../components/service-page/PageHero";
import { HighlightsGrid } from "../components/service-page/HighlightsGrid";
import { SecondaryImagesGrid } from "../components/service-page/SecondaryImagesGrid";
import { FAQSection } from "../components/service-page/FAQSection";
import { ServiceVideoSection } from "../components/service-page/ServiceVideoSection";

export default function SeoPreviewFrame() {
  useNoIndex();
  const [data, setData] = useState(null);
  const [content, setContent] = useState(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("twp_seo_preview");
      setData(raw ? JSON.parse(raw) : null);
    } catch {
      setData(null);
    }
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  if (!data) {
    return (
      <div data-testid="seo-preview-frame-empty" className="bg-black min-h-screen flex items-center justify-center text-white/50 text-sm px-6 text-center">
        Abre la vista previa desde el editor de páginas SEO.
      </div>
    );
  }

  const brandName = content?.hero_headline || "The Wedding Photographie";

  return (
    <div data-testid="seo-preview-frame" className="bg-black min-h-screen [&_a]:pointer-events-none [&_a]:cursor-default">
      <Navbar logoUrl={content?.logo_url} brandName={brandName} />

      <PageHero eyebrow={data.eyebrow} h1={data.h1} image={resolveMediaUrl(data.hero_image)} breadcrumbLabel={data.eyebrow} />

      <section className="relative bg-black py-16 md:py-20 px-6 md:px-16">
        <div className="max-w-4xl space-y-16">
          <p data-testid="seo-preview-intro" className="text-white/70 text-base md:text-lg leading-relaxed max-w-3xl">
            {data.intro}
          </p>

          <div>
            <h2 className="font-serif-display text-3xl md:text-4xl text-white mb-8">{data.highlights_title}</h2>
            <HighlightsGrid items={data.highlights} />
          </div>

          {data.video_url && <ServiceVideoSection videoUrl={data.video_url} />}

          {data.secondary_images?.length > 0 && <SecondaryImagesGrid images={data.secondary_images} />}

          <div>
            <h2 className="font-serif-display text-3xl md:text-4xl text-white mb-4">{data.faq_title}</h2>
            <FAQSection items={data.faq} />
          </div>

          <div data-testid="seo-preview-cta" className="flex flex-wrap gap-4">
            <span className="flex items-center gap-2 px-8 py-4 bg-twp-gold text-black text-xs uppercase tracking-[0.2em] font-semibold">
              <Calculator size={16} /> {data.quote_button_text}
            </span>
            {content?.whatsapp_number && (
              <span className="flex items-center gap-2 px-8 py-4 border border-white/30 text-white text-xs uppercase tracking-[0.2em] font-semibold">
                <MessageCircle size={16} /> {data.whatsapp_button_text}
              </span>
            )}
          </div>
        </div>
      </section>

      <Footer brandName={brandName} logoUrl={content?.logo_url} />
    </div>
  );
}
